import { useContext } from 'react';
import { SearchContext } from "./SearchContext";
export var useSearchContext = function useSearchContext() {
  var context = useContext(SearchContext);
  if (context === undefined) {
    throw new Error('useSearchContext must be used within a SearchContextProvider');
  }
  return context;
};